// extracted by mini-css-extract-plugin
module.exports = {"encodedData":"styles_encodedData__a0YR1","showMore":"styles_showMore__Rnax4","monospace":"styles_monospace__7KMvP","zeroes":"styles_zeroes__lT5w6"};